import React from 'react';
import cx from 'classnames';

import { SimpleBarChart } from '@magoosh/lib/charts';

import { SubjectPerformance } from '../types';

import colors from '@magoosh/lib/styles/colors.module.scss';
import style from './style.module.scss';

interface Props {
  subjects: SubjectPerformance[];
}

export default (props: Props) => {
  return (
    <div className="d-flex flex-column gap-s">
      {
        props.subjects.map((subject) => (
          // This mirrors the way that performance by subject is shown in analytics
          // performance_by_subject.tsx
          <div key={subject.slug} className="align-items-center d-flex gap-m gap-lg-l">
            <div className="align-items-lg-center d-flex flex-1 flex-column flex-md-row gap-xs gap-md-l">
              <div className={style.subjectName}>
                <div className="visible-xs">
                  <span><strong>{subject.name}</strong></span>
                  <span className="text-gray-light u-margin-L-xs" style={{ fontSize: 12 }}>
                    {(() => {
                      if (!subject.answers.total) {
                        return 'No Activity';
                      } else if (subject.gradingType === 'percentage') {
                        return `${subject.answers.correct} of ${subject.answers.total} correct`;
                      } else {
                        return `${subject.answers.total} answered`;
                      }
                    })()}
                  </span>
                </div>

                <div className="hidden-xs">
                  <strong>{subject.name}</strong>

                  <div className="text-gray-light" style={{ fontSize: 12 }}>
                    {(() => {
                      if (!subject.answers.total) {
                        return 'No Activity';
                      } else if (subject.gradingType === 'percentage') {
                        return `${subject.answers.correct} of ${subject.answers.total} correct`;
                      } else {
                        return `${subject.answers.total} answered`;
                      }
                    })()}
                  </div>
                </div>
              </div>

              <div className="flex-1">
                <SimpleBarChart
                  colorPalette={{ dark: colors.dataDarkPurple, light: colors.dataMutedPurple }}
                  data={subject.answers.data}
                  hideLabel
                />
              </div>
            </div>
          </div>
        ))
      }
    </div>
  );
};
